//dependencies
import $ from "jquery";

export default function() {

    function initScript() {

        // Filter changes
        $(".programs-keyword-form-control").on("keyup", function(e){
            var keyword = $(this).val();
            if(keyword != "" && keyword.length >= 3)
            {
                // Passing * allows us to get results for three characters or less.
                getPredictiveProgramData(keyword, $(this));
            }
            else
            {
                var $predictiveSearchResults = $("#predictiveSearchProgramsPage");
                $predictiveSearchResults.html();
                $predictiveSearchResults.hide();
            }
            
        });

        $("body").on("click", "li.result-item", function(){
            // Put the value of what was clicked on into the search.
            //$(this).closest("form").find(".search-input").val($(this).html());
            $(this).closest("div.row").find("#predictiveSearchProgramsPage").html();
        });

        $("body").on("click", function(){
            var $predictiveSearchResults = $("#predictiveSearchProgramsPage");
            $predictiveSearchResults.html();
            $predictiveSearchResults.hide();
        });

        // Initial Load
        getProgramData();

        $(".programs-keyword-search-btn").on("click", function(e) {
            e.preventDefault();
            getProgramData();
        });

        $(".programs-form-check-input").on("change", function () {
            getProgramData();
        });

        // On show more click
        $(".load-more").on("click", function() {
            showMore();
        });

    }

    function showMore()
    {   
        var showAmount = 10;
        var $degreesAndProgramsResults = $("#degreesAndProgramResults");

        $degreesAndProgramsResults.find("div.program-tile:hidden:lt(" + showAmount + ")").show();

        // if there are no more results, hide the load more button.
        if($degreesAndProgramsResults.find("div.program-tile:hidden").length <= 0){
            $(".load-more").hide();
        }

    }

    function getPredictiveProgramData(keyword)
    {
        var keyword = $(".programs-keyword-form-control").val();

        var degreeTypes = "";

        $.ajax({
            url: window.curry.degreesandprogramsFeed,
            type: "POST",
            data: {
                Keyword: keyword,
                DegreeTypes: degreeTypes,
                displayType: "predictive"
            },
            success: function (response) {

                var $predictiveSearchResults = $("#predictiveSearchProgramsPage");
                    
                if(response != ""){
                        
                    $predictiveSearchResults.html(response);
                    $predictiveSearchResults.show();
                }
                else{
                    $predictiveSearchResults.hide();
                }

            },
            error: function (xhr) {
                //Do Something to handle error
                alert("An error has occurred. Please contact an andministrator.");
            }
        });
    }

    function getProgramData(predictiveKeyword)
    {
        var keyword = $(".programs-keyword-form-control").val();

        var degreeTypes = $(".programs-form-check-input:checked").map(function(){
            return $(this).val();
        }).get();

        $.ajax({
            url: window.curry.degreesandprogramsFeed,
            type: "POST",
            data: {
                Keyword: keyword,
                DegreeTypes: degreeTypes
            },
            success: function (response) {

                var $degreesAndProgramsResults = $("#degreesAndProgramResults");
                $degreesAndProgramsResults.html(response);
                
                var showAmount = 10;

                // Only show a certain amount.
                var $tiles = $degreesAndProgramsResults.find("div.program-tile");
                
                $tiles.hide();
                
                $degreesAndProgramsResults.find("div.program-tile:lt(" + showAmount + ")").show();

                // Determine if the load more button should show up.
                if($degreesAndProgramsResults.find("div.program-tile:hidden").length <= 0){
                    $(".load-more").hide();
                }
                else {
                    $(".load-more").show();
                }
            },
            error: function (xhr) {
                //Do Something to handle error
                alert("An error has occurred. Please contact an andministrator.");
            }
        });
    }

    initScript();
}


// WEBPACK FOOTER //
// ./src/ui/js/apps/degreesAndPrograms.js